export const CLOSE_ACTIVE_MODAL = 'CLOSE_ACTIVE_MODAL'
export const SET_ACTIVE_ORGANIZATION_ID = 'SET_ACTIVE_ORGANIZATION_ID'
export const SET_ACTIVE_USER_ID = 'SET_ACTIVE_USER_ID'
export const SET_WARNING_MESSAGE = 'SET_WARNING_MESSAGE'
export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL'
export const CREATE_TOASTER_MESSAGE = 'CREATE_TOASTER_MESSAGE'
export const DISMISS_TOASTER_MESSAGE = 'DISMISS_TOASTER_MESSAGE'
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS'
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS'
export const TOGGLE_FOCUS_MODE = 'TOGGLE_FOCUS_MODE'
export const CREATE_DETACHED_NOTE_WINDOW = 'CREATE_DETACHED_NOTE_WINDOW'
export const SET_DETACHED_MODE = 'SET_DETACHED_MODE'
export const SET_OUTLINE_CONTAINER_ID = 'SET_OUTLINE_CONTAINER_ID'
export const RESET_SELECTED_NOTE_IDS = 'RESET_SELECTED_NOTE_IDS'
export const COLLAPSE_SIDEBAR = 'COLLAPSE_SIDEBAR'
export const UNCOLLAPSE_SIDEBAR = 'UNCOLLAPSE_SIDEBAR'
export const TOGGLE_CHANNELS_LIST = 'TOGGLE_CHANNELS_LIST'
export const SET_ROUTE_PARAMS = 'SET_ROUTE_PARAMS'
export const START_DIRECT_EDITING_NOTE = 'START_DIRECT_EDITING_NOTE'
export const STOP_DIRECT_EDITING_NOTE = 'STOP_DIRECT_EDITING_NOTE'
